import React from "react";
import { motion } from "framer-motion";
import styles from "./Carddata.module.css";

const CardWidget = ({
  title,
  subtitle,
  paragraph,
  list,
  variants,
  icon,
  row = 3,
}) => {
  // Calculate width per card based on row count
  const getCardWidth = () => {
    return `${100 / row}%`; // 3 per row = 33.33%, 2 per row = 50%, 1 per row = 100%
  };

  return (
    <motion.div
      className={`${styles.motionCard}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0 }}
      transition={{ duration: 0.6, delay: 0.3 }}
      variants={variants}
    >
      <div className={`card border-0 ${styles.card_main}`}>
        <div className={`card-body ${styles.cardBody}`}>
          <div className={styles.titleRow}>
            {icon && (
              <span className={styles.legendIcon}>
                <i className={icon}></i>
              </span>
            )}

            {title && (
              <h5 className={`card-title main_subheading ${styles.cardTitle}`}>
                {title}
              </h5>
            )}
          </div>

          {subtitle && <h5 className="subtitle mb-3">{subtitle}</h5>}
          {paragraph && <p className="card-text main_paragraph">{paragraph}</p>}
          {Array.isArray(list) && list.length > 0 && (
            <ul className="main_paragraph mt-3">
              {list.map((li, index) => (
                <li key={index}>
                  <p className="m-0">{li}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default CardWidget;
